import { render } from "./ButtonAndCardColor.vue?vue&type=template&id=2c9a4272"
import script from "./ButtonAndCardColor.vue?vue&type=script&lang=js"
export * from "./ButtonAndCardColor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.3.4_webpack@5.99.6_esbuild@0.25.3_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__